export default function deliveryAddressToggle() {
    const deliveryToggle = document.querySelector('.js-delivery-toggle');
    const deliveryFields = document.querySelector('.js-delivery-fields');

    if (!deliveryToggle || !deliveryFields) {
        return;
    }

    const deliveryInputs = deliveryFields.querySelectorAll('input');

    function toggleDeliveryFields(isChecked) {
        if (isChecked) {
            deliveryFields.classList.remove('hidden');
            deliveryInputs.forEach((input) => {
                if (input.name !== 'delivery_country') {
                    input.setAttribute('required', 'required');
                }
            });
        } else {
            deliveryFields.classList.add('hidden');
            deliveryInputs.forEach((input) => {
                input.removeAttribute('required');
                /* eslint-disable-next-line no-param-reassign */
                input.value = '';
            });
        }
    }

    toggleDeliveryFields(deliveryToggle.checked);

    deliveryToggle.addEventListener('change', (event) => {
        toggleDeliveryFields(event.target.checked);
    });
}

// Event listener wird jetzt in main.js registriert
// window.addEventListener('load', deliveryAddressToggle);
